<template>
  <div v-if="dviewcontentWorkspace">
    <preview-tabs
      v-if="!isMobile && !isPaxCount"
      :key="dviewcontentWorkspace"
      :workspaceID="dviewcontentWorkspace"
      :isMeetingRoom="isMeetingRoom"
    />
    <div v-if="isMobile || isPaxCount">
      <sidebar
        :fromDashboard="true"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utilsService from '@/services/utils'
import PreviewTabs from './PreviewTabs'
import Sidebar from '@/components/Sidebar'
export default {
  components: {
    PreviewTabs,
    Sidebar,
  },
  data: () => ({
    isMeetingRoom: false,
    isPaxCount: true,
  }),
  computed: {
    ...mapState('app',['locale', 'dviewcontentWorkspace']),
    isMobile () {
      return utilsService.isMobile() 
    },
    userID () {
      return utilsService.getUser()
    },
  },
  watch: {
    'dviewcontentWorkspace' (v) {
      if(v) this.handleGetContentTypes()
    },
  },
  mounted () {
    this.handleGetContentTypes()
  },
  methods: {
    async handleGetContentTypes () {
      try {
        this.isPaxCount = await new Promise((resolve) => api.getAllWithoutLimit('system', `v1/internal/users/${this.userID}/activity-barcelo-01-permissions-pax-count`)
          .then(response => {
            resolve(response && response.filter(x => x !== null).length > 0 ? true : false)
          })
          .catch(error => {
            console.log(error)
            resolve(false)
          }))
        const url = `v1/internal/workspaces/${this.dviewcontentWorkspace}/sidebar`
        api.getAllWithoutLimit ('dviewcontent', url)
          .then(response => {
            this.isMeetingRoom = response.filter(x => x.icon === 'mdi-sign-real-estate').length > 0
          })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

